import {
  reactQueryGet,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";

const show = (id: number) =>
  reactQueryGet(internalApi.mediaTranscripts.show({ id }));

const update = (id: number, params: any) =>
  reactQueryPut(internalApi.mediaTranscripts.update({ id }), params);

export const mediaTranscriptApi = {
  show,
  update,
};
